<!-- 新闻，文章类详情页面 -->
<template>
  <div class="">
    <PCNavbar />
    <div class="main-wrap">
      <div class="block-wrap">
        <div class="article">
          <div class="article-title">{{ detail.title }}</div>
          <div class="article-info">{{ detail.time }}</div>
          <div class="article-content" v-html="detail.content"></div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { formatDate } from "@/utils/tools";
import PCNavbar from "@/components/navbar/index";
import Footer from "@/components/footer/index";

export default {
  name: "DonateDetail",
  components: { PCNavbar, Footer },
  data() {
    return {
      detail: {},
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      const res = await CifuAPI.getArticleDetail({ id: this.$route.query.id });
      res.data.time = formatDate(res.data.show_time, "YYYY.MM.DD");
      this.detail = res.data;
    },
  },
};
</script>

<style lang="scss" scoped>
.article {
  padding-top: 50px;
  margin-top: 50px;
  &-title {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 32px;
    color: #663301;
  }
  &-info {
    font-size: 24px;
    color: #828282;
    line-height: 26px;
  }
  &-content {
    padding-top: 32px;
    font-size: 20px;
    color: #4f4f4f;
    line-height: 32px;
  }
}
</style>
